import { z } from 'zod';

import { MERSMINStatus } from '../../../loan/MERS';
import { Checkbox, DateString } from '../../fields';

export const MERSCreateFields = z.object({
  registrationDate: DateString.optional(),
  MIN: z.string().optional(),
  MINStatus: MERSMINStatus.optional(),
  orgId: z.string().optional(),
  momFlag: Checkbox.optional(),
});

export type MERSCreateFields = z.infer<typeof MERSCreateFields>;
